import React, { useContext, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { REFUND_STUDENT_INVOICE } from "../../../Schema/StudentPayment";
import { translateLauguage } from "../../../Function/Translate";
import moment from "moment";
import { currencyFormat } from "../../../Function/DynamicFn";

export default function RefundInvoice({
  open,
  handleClose,
  editData,
  studentId,
  setRefetch,
}) {

  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [remarkRefund, setRemarkRefund] = useState("");

  const [createRefund] = useMutation(REFUND_STUDENT_INVOICE, {
    onCompleted: ({ createRefund }) => {
      setLoading(false);
      if (createRefund?.status === true) {
        setAlert(true, "success", createRefund?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", createRefund?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });


  const handleGetAdditional = (addArray) => {
    let totalAdd = 0;
    addArray?.map((row) => {
      totalAdd += row?.total
    })

    return totalAdd;
  }

  let userLogin = JSON.parse(window.localStorage.getItem("userLogin"));

  const handleRefundAmount = () => {
    console.log({
      academicYearId: editData?.academicYearId?._id,
      invoiceId: editData?._id,
      programmeId: editData?.classId?.programme?._id,
      refundAmount: editData?.netAmount + handleGetAdditional(editData?.additionalFee),
      refundBy: userLogin?._id,
      refundDate: moment().format("YYYY-MM-DD"),
      studentId: studentId,
      remark: remarkRefund,
    })

    setLoading(true);
    createRefund({
      variables: {
        input: {
          academicYearId: editData?.academicYearId?._id,
          invoiceId: editData?._id,
          programmeId: editData?.classId?.programme?._id,
          refundAmount: editData?.netAmount + handleGetAdditional(editData?.additionalFee),
          refundBy: userLogin?._id,
          refundDate: moment().format("YYYY-MM-DD"),
          studentId: studentId,
          remark: remarkRefund,
        }
      }
    })
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">

      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Refund Invoice
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={1}>

          <Grid item xs={12}>
            <Stack direction="row" spacing={1}>
              <Typography textAlign="left" width="130px">
                Invoice ID
              </Typography>
              <Typography textAlign="center" fontWeight="bold">
                : {moment(editData?.createdAt).format("YYYY")}-{editData?.invoiceId?.toString()?.padStart(6, "0")}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Typography textAlign="left" width="130px">
                Total Amount
              </Typography>
              <Typography textAlign="center" fontWeight="bold">
                : $ {currencyFormat(editData?.netAmount + handleGetAdditional(editData?.additionalFee))}
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={12} mt={2}>
            <Typography textAlign="center">
              Do you really want to refund this invoice?
            </Typography>
          </Grid>

          <Grid item xs={12} mt={2}>
            <Typography textAlign="left">
              Memo
            </Typography>
            <TextField
              value={remarkRefund}
              onChange={(e) => setRemarkRefund(e.target.value)}
              fullWidth
              multiline
              placeholder="remark"
            />
          </Grid>



          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-refund" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button
                className={remarkRefund === "" ? "" : "btn-refund"}
                fullWidth
                onClick={handleRefundAmount}
                disabled={remarkRefund === "" ? true : false}
              >
                Refund
              </Button>
            )}
          </Grid>

        </Grid>
      </DialogContent>
    </Dialog>
  );
}
